import * as S from './styles'
import { useCaseBanner } from './useCaseBanner'
import { Image, Text } from '@/components'
import { CaseBanner, Color } from '@/service/api/casePage'

export type CaseBannerContainerProps = {
  data: CaseBanner
  color: Color
}
export const CaseBannerContainer: React.FC<CaseBannerContainerProps> = ({
  data,
  color,
}) => {
  const { fontSizes, responsiveSizes } = useCaseBanner()
  return (
    <S.CaseBannerContainer
      backgroundColor={color.secondary}
      color={color.primary}
    >
      <Image
        src={data.banner.url}
        alt={data.title}
        defaultSize={{
          height: 280,
          width: 480,
        }}
        responsiveSizes={responsiveSizes}
        className="banner-img"
      />
      <div className="banner-info">
        <Text size={fontSizes.title} color="darkgray" className="title">
          {data.title}
        </Text>
        {data.topics.length > 0 && (
          <div className="topics">
            {data.topics.map((topic) => (
              <Text
                key={topic.title}
                size={fontSizes.topicTitle}
                color="darkgray"
              >
                - {topic.title}
              </Text>
            ))}
          </div>
        )}
      </div>
    </S.CaseBannerContainer>
  )
}
